module.exports = __webpack_public_path__ + "static/media/hachLogo.49787030.png";